/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class, no-nested-ternary */
import { FC, useState } from 'react';
import { Icon } from 'learning-panel-components';
import styles from './assignedContent.module.scss';

const AssignedContentCollapsed: FC<AssignedContentCollapsedProps> = (props: AssignedContentCollapsedProps) => {
    const { onExpand, percent } = props;
    const [isHovered, setIsHovered] = useState<boolean>(false);

    return (
        <div
            className={styles['assigned-content-unexpand']}
            onMouseOver={(): void => setIsHovered(true)}
            onMouseLeave={(): void => setIsHovered(false)}
            onClick={() => onExpand(true)}
        >
            {isHovered && <Icon data-testid="arrow-icon" name={'upDownExpand'} />}
            <Icon data-testid="arrow-icon" name={'progress'} className={styles.icon} />
            <div className={styles.text}>{percent}%</div>
        </div>
    );
};

interface AssignedContentCollapsedProps {
    isLoading: boolean;
    percent: number;
    onExpand: Function;
}

export default AssignedContentCollapsed;
